export default "__VITE_ASSET__DFnUfFCn__"